<template>
  <div id="systemFeedback" class="page-wrap">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>数据趋势</el-breadcrumb-item>
        <el-breadcrumb-item>汇总数据总量统计</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page">
      <section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
        <h1>
          汇总数据总量统计
        </h1>
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="统计时间" :label-width="formLabelWidth">
            <el-date-picker
             size="small"
             v-model="searchformDate"
             type="monthrange"
             range-separator="至"
             start-placeholder="开始月份"
             end-placeholder="结束月份"
             clearable>
           </el-date-picker>
          </el-form-item>
          <el-form-item></el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="oneStep()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
      <div class="page2">
      <el-row>
        <el-col :span="24">
          <el-button @click="downTable" type="primary" size="small" :loading="downTableTrue" style="margin-bottom: 8px;">导出</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" style="width: 100%;margin-top: 5px;" v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <el-table-column prop="syncdate" label="日期" width="120">
        </el-table-column>
        <el-table-column prop="brmnum" label="品牌">
        </el-table-column>
        <el-table-column prop="dealernum" label="经销商">
        </el-table-column>
        <el-table-column prop="shopwhitenum" label="店铺(白)">
        </el-table-column>
        <el-table-column prop="shopgreynum" label="店铺(灰)">
        </el-table-column>
        <el-table-column prop="productnum" label="售价">
        </el-table-column>
        <el-table-column prop="itemlistnum" label="商品入库">
        </el-table-column>
        <el-table-column prop="markingnum" label="打标">
        </el-table-column>
        <el-table-column prop="monitoringshopnum" label="监控店铺">
        </el-table-column>
        <el-table-column prop="monitoringproductnum" label="监控产品">
        </el-table-column>
        <el-table-column prop="monitoringlinknum" label="监控链接">
        </el-table-column>
        <el-table-column prop="lowpricenum" label="违规数">
        </el-table-column>
        <el-table-column prop="banshopnum" label="禁售数">
        </el-table-column>
        <el-table-column prop="noticenum" label="通知">
        </el-table-column>
        <el-table-column prop="reviewnum" label="复查数">
        </el-table-column>
        <el-table-column prop="reviewtimeoutnum" label="复查超时">
        </el-table-column>
        <el-table-column prop="reportnum" label="投诉数">
        </el-table-column>
        <el-table-column prop="inreportnum" label="审核中">
        </el-table-column>
        <el-table-column prop="reportsuccessnum" label="投诉成功">
        </el-table-column>
        <el-table-column prop="reportfailnum" label="投诉失败">
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import pagination from "../../components/dataTable/pagination";
  export default {
    data() {
      return {
        formLabelWidth: "100px",
        tableLoading:false,
        downTableTrue:false,
        tableData: [],
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        totalNum: 10,
        searchformDate: '',//时间
      }
    },
    mounted() {
      this.oneStep()
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.oneStep();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.oneStep();
      },
      // 下载
      downTable(row) {
        let that = this;
        that.downTableTrue = true
        let datas = {}
        if (this.searchformDate) {
          if (this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10) == 'NaN-NaN-Na') {
            datas.starttime = ''
          } else {
            datas.starttime = this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,8) + '01';
          }
          if (this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10) == 'NaN-NaN-Na') {
            datas.endtime = ''
          } else {
            datas.endtime = this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,8) + '31';
          }
        }
        fetch({
          url: "hcm/hcmBrmanalysis/hcmBrmanalysisDownload",
          method: "get",
          params: datas,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "汇总数据总量统计.xlsx");
          document.body.appendChild(link);
          link.click();
          that.downTableTrue = false
        });
      },

      // 数据源
      oneStep() {
        this.tableLoading = true
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        if (this.searchformDate) {
          if (this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10) == 'NaN-NaN-Na') {
            params.starttime = ''
          } else {
            params.starttime = this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,8) + '01';
          }
          if (this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10) == 'NaN-NaN-Na') {
            params.endtime = ''
          } else {
            params.endtime = this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,8) + '31';
          }
        }
        fetch({
          url: "hcm/hcmBrmanalysis/getBrmanalysis",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableLoading = false
            this.tableData = data.content
            this.totalNum = data.totalElements
          } else {
            this.tableLoading = false
            this.$message.error(res.message)
          }
        })
      },
    },
    components: {
      pagination
    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 28px;
    line-height: 28px;
    background-color: white;
  }
  .page {
    margin: 20px 20px 10px 20px;
    background-color: white;
  }
  .page2 {
    margin: 0px 20px 10px 20px;
    background-color: white;
    padding: 20px;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }
  .widthStyle {
    margin: 0px 0px 15px 10px;
    width: 70%;
  }
</style>
<style lang="scss">
#systemFeedback {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-button+.el-button {
    margin-left: 0px;
  }
  .bottom_page .el-pagination {
    text-align: right;
    margin-top: 0px;
    padding-bottom: 0px;
  }
}
</style>
